import React from "react";
import {Typography, Divider} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import StorageIcon from '@mui/icons-material/Storage';

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function TrafficMenuSnippet({permissions}) {
    if (!(permissions.canTrafficManage || permissions.canAdmin || permissions.canLiveOps)) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Traffic</Typography>
            <NavigationButton displayName="Live Dashboard" toLink="/live-dashboard">
                <SupportAgentIcon/>
            </NavigationButton>

            {
                (permissions.canTrafficManage || permissions.canAdmin)
                &&
                <>
                    <NavigationButton displayName="Manage Schedule" toLink="/schedule">
                        <PunchClockIcon/>
                    </NavigationButton>
                    <NavigationButton displayName="Schedule Planner" toLink="/plan-schedule">
                        <StorageIcon/>
                    </NavigationButton>
                </>
            }
            <Divider sx={styles.divider}/>
        </>
    );
}